import Body from './Body'
import Container from './Container'

export const Page = {
  Container,
  Body
}
